var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7568 3.75977C12.7955 3.06511 11.6397 2.69095 10.4537 2.69043C8.95866 2.69122 7.52501 3.28519 6.46745 4.34196C5.41359 5.3966 4.81985 6.8254 4.81592 8.31633C4.81592 14.8898 2 16.77 2 16.77H18.9074C18.9074 16.77 16.944 15.4601 16.2964 11.2065",
    stroke: "#8400E6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 20.0001C13.6412 20.6081 13.1298 21.1134 12.5155 21.4668C11.9023 21.8164 11.2073 22.0003 10.5 22.0001C9.7907 22.0002 9.09368 21.8164 8.47806 21.4668C7.86435 21.1149 7.35464 20.6091 7 20.0001",
    stroke: "#8400E6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.062 10.8419C19.4423 10.8419 21.372 8.91219 21.372 6.53183C21.372 4.15147 19.4423 2.2218 17.062 2.2218C14.6816 2.2218 12.752 4.15147 12.752 6.53183C12.752 8.91219 14.6816 10.8419 17.062 10.8419Z",
    stroke: "#8400E6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.54a523a59f5115ad757f71d71ef4c9ab.svg";
export { ForwardRef as ReactComponent };